import { memo } from 'react';
import type { RenderResult } from '@markroom/renderer';

/**
 * Renders the markdown React tree. Memoized on the render result so unrelated
 * re-renders (zoom, find, theme) do NOT reconcile this subtree — which would
 * otherwise wipe the imperatively-injected mermaid SVGs and find highlights.
 */
export const DocumentView = memo(function DocumentView({ render }: { render: RenderResult }) {
  return <article className="markroom-doc">{render.element}</article>;
});
